'use strict';
'use es6';

// default configurations for signup app

Object.defineProperty(exports, "__esModule", {
  value: true
});
var configDefaults = {
  totalSteps: 2
};

exports.default = configDefaults;
module.exports = exports['default'];